<template>
  <div>
    <SampleDescriptions :data="formData" />
    <el-form
      class="mt-2"
      ref="form"
      :model="formData"
      :disabled="disabled"
      :rules="rules"
      size="mini"
      label-width="100px"
      label-position="left"
    >
      <div class="el-form-row">
        <el-form-item :label="$l('form_label_expoSampleBrand') || '展品系列'">
          <el-input
            v-model="formData.expoSampleBrand"
            :placeholder="
              $l('form_placeholder_expoSampleBrand') || '请输入系列名'
            "
            :maxlength="28"
            show-word-limit
            clearable
          />
        </el-form-item>
        <el-form-item
          :label="$l('form_label_expoSampleSpec') || '展品尺寸'"
          prop="expoSampleSpec"
        >
          <el-input
            v-model="formData.expoSampleSpec"
            :placeholder="
              $l('form_placeholder_expoSampleSpec') || '请输入展品尺寸'
            "
            :maxlength="70"
            show-word-limit
            clearable
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_expoSampleName') || '展品名称'"
          prop="expoSampleName"
        >
          <el-input
            v-model="formData.expoSampleName"
            :placeholder="
              $l('form_placeholder_expoSampleName') || '请输入展品名称'
            "
            :maxlength="60"
            show-word-limit
            clearable
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_expoSampleDesc') || '展品描述'"
          prop="expoSampleDesc"
        >
          <el-input
            v-model="formData.expoSampleDesc"
            :placeholder="
              $l('form_placeholder_expoSampleDesc') || '请输入展品描述'
            "
            type="textarea"
            :rows="5"
            :maxlength="120"
            show-word-limit
            clearable
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_displayFabric') || '展品面料'"
          prop="fabric"
          ref="faceFabricForm"
        >
          <SampleFabric
            :isFabricPosition.sync="formData.isFabricPosition"
            :fabric.sync="formData.fabric"
            :faceFabric.sync="formData.faceFabric"
            :backFabric.sync="formData.backFabric"
            :innerFabric.sync="formData.innerFabric"
            @change="() => $refs.faceFabricForm.clearValidate()"
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item :label="$l('form_label_remark') || '展品备注'">
          <el-input
            v-model="formData.remark"
            :placeholder="$l('form_placeholder_remark') || '请输入展品备注'"
            type="textarea"
            :rows="5"
            :maxlength="500"
            show-word-limit
            clearable
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_costPrice') || '成本价格'"
          style="width: 50%;"
        >
          <el-input
            :value="`${formData.costPrice || 0} ${formData.costCurrency || ''}`"
            readonly
          />
        </el-form-item>
        <el-form-item :label="$l('form_label_scmName') || '样品工厂'">
          <el-input :value="formData.scmName" readonly />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_quotedMethod') || '报价方式'"
          style="width: 50%;"
          prop="quotedMethod"
        >
          <dict-select
            v-model="formData.quotedMethod"
            url="/sys/common/dict/system"
            :body="{ dictType: 'quotedMethod' }"
            :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            filterable
            size="mini"
          />
        </el-form-item>
        <el-form-item
          :label="$l('form_label_quotedPrice') || '参考报价'"
          prop="quotedPrice"
        >
          <el-row :gutter="10">
            <el-col :span="14">
              <el-input-number
                v-model="formData.quotedPrice"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                :controls="false"
                size="mini"
                :min="0"
                :step="0.01"
                :precision="2"
                step-strictly
                style="width: 100%"
              />
            </el-col>
            <el-col :span="10">
              <dict-select
                v-model="formData.currencyUnit"
                url="/master/common/dict/biz"
                :body="{ dictType: 'currencyUnit' }"
                :placeholder="
                  $l('form_currencyUnit_placeholder') || '请选择报价货币单位'
                "
                filterable
                size="mini"
              />
            </el-col>
          </el-row>
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item :label="$l('form_label_character') || '产品特性'">
          <SampleProperties
            v-model="formData.listProperties"
            :disabled="disabled"
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item :label="$l('form_label_createBy') || '选品人'">
          <el-input :value="formData.createByName" readonly />
        </el-form-item>
        <el-form-item :label="$l('form_label_createDate') || '选品时间'">
          <el-input :value="formData.createDate" readonly />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item :label="$l('form_label_modifyBy') || '修改人'">
          <el-input :value="formData.modifyByName" readonly />
        </el-form-item>
        <el-form-item :label="$l('form_label_modifyDate') || '修改时间'">
          <el-input :value="formData.modifyDate" readonly />
        </el-form-item>
      </div>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SampleDescriptions from './sample-descriptions.vue'
import SampleFabric from '../sample-fabric'
import SampleProperties from '../sample-properties'
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  components: { SampleDescriptions, SampleFabric, SampleProperties },
  props: {
    disabled: { type: Boolean, default: false },
    expoSampleCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      rules: {
        expoSampleSpec: [{ trigger: 'blur', required: true, message: ' ' }],
        expoSampleName: [{ trigger: 'blur', required: true, message: ' ' }],
        expoSampleDesc: [{ trigger: 'blur', required: false, message: ' ' }],
        fabric: [{ trigger: 'blur', required: true, message: ' ' }],
        quotedMethod: [{ trigger: 'change', required: true, message: ' ' }],
        quotedPrice: [
          { trigger: 'blur', required: true, message: ' ' },
          {
            validator: (rule, value, callback) => {
              const { currencyUnit } = this.formData
              if (!value || value <= 0) return callback(new Error(' '))
              if (!currencyUnit) return callback(new Error(' '))
              callback()
            },
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.expoSampleCode) return
      this.$api
        .expoSampleDetailApi({ expoSampleCode: this.expoSampleCode })
        .then((res) => {
          this.formData = res.body
          setTimeout(() => {
            this.$refs.form.clearValidate()
          }, 0)
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const { listProperties } = this.formData
      const listPropertiesImageCode = listProperties.map(
        (item) => item.samplePropertiesImageCode
      )
      this.loadingOpen()
      const res = await this.$api
        .expoSampleSaveApi({ ...this.formData, listPropertiesImageCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .border-top-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }

  .el-form {
    .el-form-row {
      display: flex;
      border: 1px solid #ebeef5;
      border-top: none;
      border-left: none;
      .el-form-item {
        margin: 0 !important;
        position: relative;
        width: 100%;

        .el-form-item__label {
          color: #909399;
          background: #fafafa;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          padding: 8px 10px;
          border-left: 1px solid #ebeef5;
          border-right: 1px solid #ebeef5;
          font-size: 12px !important;
          position: absolute;
          bottom: 0;
          top: 0;
        }

        .el-form-item__content {
          padding: 0 5px;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          color: #606266;
          font-size: 12px !important;
          > div {
            margin: 3.2px 0;
          }
          > .el-input {
            input[readonly] {
              border: none;
              background-color: #fff;
              color: #606266;
              cursor: auto;
            }
          }
          .el-input-number .el-input__inner {
            text-align: left;
          }
          .no-error {
            .el-input__inner {
              border-color: #dcdfe6 !important;
            }
          }
        }
      }
    }

    > div:first-child {
      border-top: 1px solid #ebeef5;
    }
  }
}
</style>
